<template>
  <div class="d-flex justify-center flex-wrap gap-3">
    <VBtn
      v-for="link in authProviders"
      :key="link.icon"
      icon
      :href="link.url"
      :color="$vuetify.theme.current.dark ? link.colorInDark : (fullDark?link.colorInDark:link.color)"
      target="_blank"
      rel="noopener noreferrer"
      variant="tonal"
      size="38"
      class="rounded"
    >
      <VIcon
        size="25"
        :icon="link.icon"
      />
    </VBtn>
  </div>
</template>

<script setup>
const props= defineProps({
  fullDark: {
    type: Boolean,
    default: false,
  },
})

const authProviders = [
  {
    icon: 'tabler-brand-facebook',
    color: '#242540',
    colorInDark: '#FFF',
    url: 'https://www.facebook.com/IEFlaflorestaMosquera',
  },
  {
    icon: 'tabler-brand-instagram',
    color: '#242540',
    colorInDark: '#FFF',
    url: 'https://www.instagram.com/ieflafloresta/',
  },
  {
    icon: 'tabler-brand-youtube',
    color: '#242540',
    colorInDark: '#FFF',
    url: 'https://www.youtube.com/channel/UCwCuXGtf9ztX4qdJV_dIZHQ',
  },
  {
    icon: 'tabler-brand-whatsapp',
    color: '#242540',
    colorInDark: '#FFF',
    url: 'https://api.whatsapp.com/send?phone=573013597368',
  }, 
]
</script>
